<app-sub-header-category></app-sub-header-category>
<div class="smooth-scrolling">

    <app-responsive-searchbar-black-border></app-responsive-searchbar-black-border>

    <!-- individual brand start -->
    <section class="individual-brand-section">
        <div class="individual-brand-container">
            <div class="row">
                <div class="col-sm-3 d-lg-flex d-none leftSide individual-brand">
                    <div class="brand-category">
                        <div class="filter-main">
                            <div class="sortby">
                                <div class="select-title" [ngClass]="sortBy ? 'open' : ''" (click)="setSortBy()">
                                    Sort By
                                </div>
                                <ul [ngClass]="sortBy ? 'open' : ''">
                                    <li data-value="1"><a (click)="selectRelevance()">Relevance</a></li>
                                    <li data-value="2"><a (click)="selectPriceSort(false)">Price low to high</a>
                                    </li>
                                    <li data-value="3"><a (click)="selectPriceSort(true)">Price high to low</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="caetgory-list">
                            <h4>SKIN TYPE</h4>

                            <ul>
                                <li class="category-checkbox"
                                    *ngFor="let skinType of mGetSkinTypeResponse.data, let i = index">
                                    <input id="skinType_mob_{{skinType.id}}" type="checkbox" 
                                    name="skinType" [checked]="skinTypeArray && skinTypeArray.length && skinTypeArray.includes(skinType.id)"
                                    (click)="selectSkinType(skinType.id)">
                                    <label for="skinType_mob_{{skinType.id}}">{{skinType.name}}</label>
                                </li>
                            </ul>
                        </div>
                        <div class="caetgory-list">
                            <h4>SKIN CONCERN</h4>
                            <ul>
                                <li class="category-checkbox"
                                    *ngFor="let skinConcern of mGetSkinConcernResponse.data, let i = index">
                                    <input id="skinConcern_mob_{{skinConcern.id}}" type="checkbox" name="skinConcern"
                                        (click)="selectSkinConcern(skinConcern.id)"
                                        [checked]="skinConcernArray && skinConcernArray.length && skinConcernArray.includes(skinConcern.id)">
                                    <label for="skinConcern_mob_{{skinConcern.id}}"
                                        class="lbl">{{skinConcern.name}}</label>
                                </li>
                            </ul>
                        </div>
                        <div class="caetgory-list">
                            <h4>Gender</h4>

                            <ul>
                                <li class="category-checkbox">
                                    <input (click)="selectGender(0)" type="radio" id='all' name="gender">
                                    <label for="all">Any</label>
                                </li>
                                <li class="category-checkbox">
                                    <input (click)="selectGender(1)" type="radio" id='male' name="gender">
                                    <label for="male">Male</label>
                                </li>
                                <li class="category-checkbox">
                                    <input (click)="selectGender(2)" type="radio" id='female' name="gender">
                                    <label for="female">Female</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xxl-9 col-lg-9 col-12">
                    <div class="i-brand-content">
                        <div *ngIf="mGetBrandResponse && mGetBrandResponse.data" class="i-brand-title">
                            <h3>{{mGetBrandResponse && mGetBrandResponse.data &&
                                mGetBrandResponse.data[0].name}}</h3>
                            <div [innerHTML]="mGetBrandResponse && mGetBrandResponse.data[0].description"></div>
                        </div>
                        <div class="services-lists">
                            <div class="row" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
                                (scrolled)="onScrollProduct()">
                                <div class="col-md-3 col-sm-6 item"
                                    *ngFor="let product of brandProductList; let i  =  index">
                                    <img *ngIf="!product.like" (click)="addtoCart(product,'wishList', i , 'suppliment')"
                                        class="like" src="assets/images/heart-svgrepo-com.svg">
                                    <img *ngIf="product.like" class="like"
                                        (click)="addtoCart(product,'wishList',i,'suppliment')"
                                        src="assets/images/heart-svgrepo-com-like.svg">
                                    <div class="listBox">
                                        <div class="face-content sup-content">
                                            <span><img [src]="product?.imageList && product?.imageList.length > 0 && product?.imageList[0]?.path ? product.imageList[0].path : 'assets/images/default-product.png'"
                                            alt="image" (click)="showProduct(product)" /></span>
                                            <div class="face-tool-content">
                                                <h5 class="set-underline-hover" (click)="showProduct(product)">{{product.name}}</h5>
                                                <p class="show-content"
                                                    *ngIf="product.description != null || product.description != ''">
                                                    <td [innerHTML]="product.description"></td>
                                                </p>
                                                <p class="show-content"
                                                    *ngIf="product.description == null || product.description == ''">
                                                    <td [innerHTML]="product.name"></td>
                                                </p>
                                                <div class="face-price">₹{{product.your_price}}</div>
                                                <ul>
                                                    <li><a class="f-bg-black" (click)="buyNow(product)">Quick Shop</a>
                                                    </li>
                                                    <li *ngIf="!product.cartQty"><a class="f-border-black"
                                                            (click)="addtoCart(product,'cart')">Add
                                                            to cart</a></li>
                                                    <li *ngIf="product.cartQty" class="product-actions">
                                                        <a class="q-wrap">
                                                            <button type="button" id="sub" class="q-sub"
                                                                (click)="removeCartItem(product,i)">-</button>
                                                            <input class="q-count" type="text" id="1"
                                                                [(ngModel)]="product.cartQty" disabled />
                                                            <button type="button" id="add" class="q-add"
                                                                (click)="addCartItem(product,i)">+</button>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Listing START -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- individual brand end -->

    <section class="filter-section">
        <div class="filter-p d-lg-none d-flex">
            <div class="button-filler">
                <a class="btn btn-primary" data-bs-toggle="offcanvas" href="#individual-brand-f" role="button"
                    aria-controls="individual-brand-f">
                    FILTER
                </a>
            </div>
            <div class="button-filler d-lg-none d-flex">
                <a class="btn btn-primary" data-bs-toggle="offcanvas" href="#sortby" role="button"
                    aria-controls="offcanvasExample">
                    SORT BY
                    <div>
                    </div>
                </a>
            </div>
            <div class="offcanvas offcanvas-start" tabindex="-1" id="individual-brand-f"
                aria-labelledby="individual-brand-f">
                <div class="offcanvas-header">
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                        aria-label="Close"></button>
                </div>
                <div class="offcanvas-body">
                    <div class="caetgory-list">
                        <h4>SKIN TYPE</h4>
                        <ul>
                            <li class="category-checkbox"
                                *ngFor="let skinType of mGetSkinTypeResponse.data; let i = index">
                                <input type="checkbox" name="skinType" (click)="selectSkinType(skinType.id)"
                                    class="skinTypeTitle" id='skinType_{{skinType.id}}'>
                                <label for="skinType_{{skinType.id}}">{{skinType.name}}</label>
                            </li>
                        </ul>
                    </div>
                    <div class="caetgory-list">
                        <h4>SKIN CONCERN</h4>
                        <ul>
                            <li class="category-checkbox"
                                *ngFor="let skinConcern of mGetSkinConcernResponse.data; let i = index">
                                <input type="checkbox" name="skinType" (click)="selectSkinConcern(skinConcern.id)"
                                    id='skinConcern_{{skinConcern.id}}'>
                                <label for="skinConcern_{{skinConcern.id}}">{{skinConcern.name}}</label>
                            </li>
                        </ul>
                    </div>
                    <div class="caetgory-list">
                        <h4>Gender</h4>
                        <ul>
                            <li class="category-checkbox">
                                <input (click)="selectGender(0)" type="radio" id='all' name="gender">
                                <label for="all">Any</label>
                            </li>
                            <li class="category-checkbox">
                                <input (click)="selectGender(1)" type="radio" id='male' name="gender">
                                <label for="male">Male</label>
                            </li>
                            <li class="category-checkbox">
                                <input (click)="selectGender(2)" type="radio" id='female' name="gender">
                                <label for="female">Female</label>
                            </li>
                        </ul>
                    </div>

                </div>
                <div class="filter-p d-lg-none  d-flex">
                    <div class="button-filler">
                        <a class="btn btn-primary" role="button" aria-controls="offcanvasExample"
                            data-bs-dismiss="offcanvas" (click)="appyFilter()">
                            APPLY
                        </a>
                    </div>
                    <div class="button-filler">
                        <a class="btn btn-primary" role="button" aria-controls="offcanvasExample"
                            data-bs-dismiss="offcanvas" (click)="clearFilter()"> CLEAR FILTERS </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class=" sortby-section">
        <div class="offcanvas offcanvas-bottom" tabindex="-1" id="sortby" aria-labelledby="offcanvasBottomLabel">
            <div class="offcanvas-header">
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                    aria-label="Close"></button>
            </div>
            <div class="offcanvas-body small ">
                <ul [ngClass]="sortBy ? 'story-hide-content' : ''">
                    <li data-value="1"><a (click)="selectRelevance()">Relevance</a></li>
                    <li data-value="2"><a (click)="selectPriceSort(false)">Price low to high</a>
                    </li>
                    <li data-value="3"><a (click)="selectPriceSort(true)">Price high to low</a></li>
                </ul>
            </div>
        </div>
    </section>
    <!-- Footer START -->
    <app-footer-bg></app-footer-bg>
    <!-- Footer END -->
</div>